<template>
  <div class="alerts-by-customer">
  <WidgetCard
    title="Alerts by customer"
    icon="team"
    :loading="loading"
    :error="error"
    :empty="emptyMessage"
  >
    <template #headerExtra>
      <a-radio-group size="small" :value="windowKey" @change="onChangeWindow">
        <a-radio-button value="3h">3H</a-radio-button>
        <a-radio-button value="12h">12H</a-radio-button>
        <a-radio-button value="1d">1D</a-radio-button>
        <a-radio-button value="3d">3D</a-radio-button>
        <a-radio-button value="7d">7D</a-radio-button>
      </a-radio-group>
    </template>
    <div class="customer-alerts" :class="{ 'customer-alerts--scroll': rows.length > 10 }">
      <a-table
        :dataSource="rows"
        :columns="columns"
        :pagination="false"
        size="small"
        rowKey="customer_id"
      />
    </div>
  </WidgetCard>
  </div>
</template>

<script>
  import WidgetCard from '@modules/Home/components/dashboard/WidgetCard.vue';
  import dashboardWidget from '@modules/Home/mixins/dashboardWidget.mixin';
  import AdminService from '../services/admin.service';

  function severityCell(record, key) {
    if (!record.alert_triage || !record.severity) {
      return '-';
    }
    return record.severity[key];
  }

  export default {
    name: 'AlertsByCustomerWidget',
    components: { WidgetCard },
    mixins: [dashboardWidget],
    data() {
      return {
        windowKey: '3h',
        rows: [],
      };
    },
    computed: {
      columns() {
        const tone = (key, color) => (text, record) => {
          const value = severityCell(record, key);
          if (value === '-' || !Number(value)) {
            return '-';
          }
          return this.$createElement('span', { style: { color, fontWeight: '600' } }, String(value));
        };
        return [
          { title: 'Customer', dataIndex: 'username' },
          { title: 'ID', dataIndex: 'customer_id', align: 'right' },
          { title: 'Alerts', dataIndex: 'alert_count', align: 'right' },
          { title: 'High', align: 'right', customRender: tone('high', '#cf1322') },
          { title: 'Med', align: 'right', customRender: tone('medium', '#d46b08') },
          { title: 'Low', align: 'right', customRender: tone('low', '#8c8c8c') },
        ];
      },
      emptyMessage() {
        return this.rows.length ? '' : 'No alerts in this window';
      }
    },
    methods: {
      onChangeWindow(e) {
        this.windowKey = e.target.value;
        this.fetchData();
      },
      fetchResource() {
        return AdminService.fetchAlertsByCustomer(this.windowKey);
      },
      applyResult(res) {
        this.rows = (res && res.customers) || [];
      }
    }
  };
</script>

<style lang="scss" scoped>
  .alerts-by-customer {
    height: auto;
  }

  .alerts-by-customer ::v-deep .dw-card__head {
    padding: 8px 10px 2px;
  }

  .alerts-by-customer ::v-deep .dw-card__body {
    padding: 2px 8px 6px;
  }

  .alerts-by-customer ::v-deep .ant-radio-button-wrapper {
    height: 24px;
    line-height: 22px;
    padding: 0 8px;
    font-size: 12px;
  }

  .alerts-by-customer ::v-deep .dw-card {
    height: auto;
    overflow: visible;
  }

  .customer-alerts {
    overflow-x: auto;
  }

  .customer-alerts--scroll {
    max-height: 320px;
    overflow: auto;
  }

  .customer-alerts ::v-deep .ant-table {
    font-size: 12px;
  }

  .customer-alerts ::v-deep table {
    width: max-content;
    min-width: 100%;
    table-layout: auto;
  }

  .customer-alerts ::v-deep .ant-table-thead > tr > th,
  .customer-alerts ::v-deep .ant-table-tbody > tr > td {
    padding: 4px 8px;
    white-space: nowrap;
  }

  .customer-alerts ::v-deep .ant-table-thead > tr > th {
    background: #fff;
  }
</style>
